import React from "react";
import AllAccount from "views/Accounts/AllAccounts";
import AllAudience from "views/Audience/AllAudience";
import Report from "views/Event_And_Signals/Report";
import CJGraph from "./CustomerJourney/CJGraph";
import Can from "Utils/Can";
import { useSelector, useDispatch } from 'react-redux';

export default function Dashboard(props) {

  const { role } = useSelector(
    (state) => state.userSetter
  );


  return (
    <>
      <div style={{  margin: "25px" }}>
        <Can obj={{ allowed: true }}>
          <Report props={props} />
        </Can>
      </div>
      <div style={{  margin: "25px" }}>
        <CJGraph props={props} />
      </div>
      {role!='publisher' && role != 'partner' && (<>
      <div style={{  display:"flex", justifyContent:"space-between", flexWrap:"wrap", padding:"25px", width:"100%" }}>
        <AllAccount />

      </div>

      <div style={{  display:"flex", justifyContent:"space-between", flexWrap:"wrap", padding:"25px", width:"100%" }}>
        <AllAudience />
      </div>
      </>)
      }

      </>
  );
}
